import { NameEntityResponse } from "../../api-models/response/NameEntityResponse";
import { FileTypeResponse } from "../../api-models/response/FileTypeResponse";
import { MediaFileResponse } from "../../api-models/response/MediaFileResponse";
import dateService from "../date-service/DateService";
import { translationService } from "../translation/TranslationService";
import { RowItemData } from "../../components/datatable/interfaces";
import { formatBytes, formatNumberBasedOnLanguage } from "../../helpers/MathHelpers";

export class InspectionFile implements RowItemData {
  id: number;
  private name: string;
  private type: FileTypeResponse;
  private contentType: string;
  private uploadedBy: NameEntityResponse;
  private uploadedDate: Date;
  private size: number;
  private analysisSuccessfullyDone: boolean;
  private segmentationSuccessfullyDone: boolean;

  constructor(inspectionFileResponse: MediaFileResponse) {
    this.id = inspectionFileResponse.id;
    this.name = inspectionFileResponse.name;
    this.type = inspectionFileResponse.type;
    this.contentType = inspectionFileResponse.contentType;
    this.uploadedBy = inspectionFileResponse.uploadedBy;
    this.uploadedDate = inspectionFileResponse.uploadedDate;
    this.size = inspectionFileResponse.size;
    this.analysisSuccessfullyDone = inspectionFileResponse.analysisSuccessfullyDone;
    this.segmentationSuccessfullyDone = inspectionFileResponse.segmentationSuccessfullyDone;
  }

  get fileName() {
    return this.name;
  }

  get displayValues() {
    return {
      type: { toDisplay: translationService.translate(`general.file-type.${this.type.name}`) },
      name: { toDisplay: this.name },
      contentType: { toDisplay: this.contentType },
      uploadedBy: { toDisplay: this.uploadedBy && this.uploadedBy.name },
      uploadedDate: {
        toDisplay: this.uploadedDate ? dateService.formatDate(this.uploadedDate) : null,
      },
      size: {
        toDisplay: this.formattedSize,
      },
    };
  }

  private get formattedSize() {
    const formattedBytes =
      this.size && `${formatBytes(this.size).amount} ${formatBytes(this.size).unit}`;
    return formatNumberBasedOnLanguage(formattedBytes);
  }
  
  get isAnalysisSuccessfullyDone(): boolean {
    return this.analysisSuccessfullyDone;
  }

  get isSegmentationSuccessfullyDone(): boolean {
    return this.segmentationSuccessfullyDone;
  }

  get fileType(): FileTypeResponse {
    return this.type;
  }
}
